export const useBoxStyles = {
    logoBox: {
        position: 'relative',
        width: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    titleBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'calc(100% + 32px)',
        padding: "5px",
        borderTopRightRadius: "4px",
        borderTopLeftRadius: "4px",
        color: "#fff",
        gap: 1,
    },
    cardHeaderBox: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 0,
        justifyContent: 'space-between',
    },
    buttonsBox: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 4,
        width: "100%",
        justifyContent: "center"
    },
    purpleBox: {
        flex: '1 1 auto',
        minWidth: 0,
        backgroundColor: 'lightgrey',
        color: '#000',
        borderRadius: '4px',
        padding: { xs: 1, sm: 1 },
    },

    taxReliefBox: {
        backgroundColor: 'highlight.main',   
        borderRadius: '4px',
        padding: 1,
        width: '80%',
        margin: '0 auto'
    },

    verticalLineBox: {
        width: '1px',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        height: '100%',
        marginX: 2,
        marginY: 1
    }
};
